import Api from '@teko/api';
import { accessTokenInterceptor } from '@teko/auth';

class NotificationService {
    constructor(notificationApiUrl) {
        this.getNotification = async (params) => {
            const { data } = await this.notificationApi.get(`/notifications`, {
                params,
            });
            return data.data;
        };
        this.markNotificationAsRead = async (notificationId) => {
            const { data } = await this.notificationApi.put(`/notification/${notificationId}/mark-read`, {});
            return data;
        };
        this.unreadCount = async (params) => {
            const { data } = await this.notificationApi.get('/notification/count-unread', {
                params,
            });
            return data;
        };
        this.registerToken = async (params) => {
            await this.notificationApi.post('notification/register-token', params);
        };
        this.unRegisterToken = async (params) => {
            await this.notificationApi.post('notification/unregister-token', params);
        };
        this.notificationApi = new Api(notificationApiUrl);
        this.notificationApi.addInterceptor(accessTokenInterceptor);
    }
}

const FCM_TOKEN = 'fcmToken';
const FCM_USER_ID = 'fcmUserId';
const FCM_TRANSPORT = 'fcm';
const FCM_REGISTER_TOKEN_SUCCESS = 'fcmRegisterTokenSuccess';

export { FCM_REGISTER_TOKEN_SUCCESS, FCM_TOKEN, FCM_TRANSPORT, FCM_USER_ID, NotificationService };
